import { DepartmentType, MerchantType, OrdinaryPersonPrefixType, PrefixNameType } from "@/enums/enums";
import { AddressDetailModel } from "../address/addressModel";

export class ContactModel extends AddressDetailModel {
  branchCode!: string;
  contactCode!: string;
  contactId!: number;
  email!: string;
  faxNumber!: string;
  isOrdinaryPerson!: boolean;
  merchantType!: MerchantType;
  name!: string;
  ordinaryPerson!: OrdinaryPersonModel;
  person!: PersonModel;
  phoneNumber!: string;
  taxNumber!: string;
  website!: string;
  taxId!: string;
}
export class OrdinaryPersonModel {
  namePrefixOther!: string;
  namePrefixType!: OrdinaryPersonPrefixType;
}

export class DepartmentModel {
  departmentOther!: string;
  departmentType!: DepartmentType;
}
export class PersonModel {
  contactPersonId!: number;
  email!: string;
  firstName!: string;
  lastName!: string;
  ordinaryPerson!: OrdinaryPersonModel;
  phoneNumber!: string;
  department!: DepartmentModel;
}

export class ContactPersonNameModel {
  firstname!: string;
  lastname!: string;
  namePrefixType!: OrdinaryPersonPrefixType | PrefixNameType;
  namePrefixOther!: string;
  isMainPerson?: boolean;
}
